<div class="card-component details-items-body">
    <div class="sections-wrapper">
        <ng-container *ngFor="let item of getItems()" [appRenderNode]="item"> </ng-container>
        <div class="related-contact-footer">
            <a (click)="toggle()">{{ fullView ? 'See less...' : 'See more...' }}</a>
        </div>
    </div>
</div>
